$('.js-tabs').on('click', '.js-tabs-link', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($($this).attr('href'));

  if (!$element.length) {
    return;
  }

  $this
    .parent()
    .addClass('is-active')
    .siblings('.is-active')
    .removeClass('is-active');

  $element
    .addClass('is-active')
    .show()
    .siblings('.is-active')
    .removeClass('is-active')
    .hide();

  $('.js-slider-products.slick-initialized').slick('refresh');
});
